import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "JobDocument/";

const getJobDocuments = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetJobDocuments?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const saveJobDocument = async (jobDocument) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveJobDocument', jobDocument, constants.REQUIRE_INTERCEPTORS);

const deleteJobDocument = async (jobDocumentId) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteJobDocument?jobDocumentId=' + jobDocumentId, constants.REQUIRE_INTERCEPTORS);

const renameJobDocument = async (jobDocumentId, newName) => await axiosInstance.post(ENDPOINTORIGIN + 'RenameJobDocument?jobDocumentId=' + jobDocumentId + "&newName=" + newName , {}, constants.REQUIRE_INTERCEPTORS);

export {
    getJobDocuments,
    saveJobDocument,
    deleteJobDocument,
    renameJobDocument
}